const endpoint = process.env.VUE_APP_API_ENDPOINT || 'http://10.99.16.39/compras/index.php/';

export default {
  // En Docker/produccion se inyecta VUE_APP_API_ENDPOINT como variable de build
  // En desarrollo local sigue usando la IP directa
  endpoint,
  // Base para scripts PHP sueltos (upload.php, etc.) que no pasan por index.php de CodeIgniter
  uploadBase: endpoint.replace('index.php/', ''),
}